import { useTheme } from '@mui/material/styles';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';
import { ActualIconProps } from 'mobx/commonTypes';
import React, { useContext } from 'react';
import { UiContext } from 'uiContext';
import cx from 'classnames';

export default function IconDTP({
  onClick,
  extColor,
  isAutoscallable = true,
  sizeKey = '16x16',
  style,
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      className={cx('icon IconDTP', onClick ? '' : 'icon_disabled')}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 17 16"
      fill={fill}
    >
      <g clipPath="url(#clip0_110_1076)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.47921 5.85938L4.88546 6.0625L5.96358 7.57812L8.57296 8.35938L11.2136 7.45312L12.3698 5.85938L10.8542 6.0625L11.4792 3.625L10.0417 4.85938L9.63546 3L8.71358 4.4375L7.54171 3.39062V5.26562L5.96358 4.85938L6.47921 5.85938ZM14.058 11.0479L17.3955 10.2869L16.369 5.13826C16.369 5.13826 15.1247 5.17703 14.4382 5.5232C13.5445 5.97384 12.6935 7.40056 12.6935 7.40056C12.6935 7.40056 11.7153 8.56747 10.5537 8.81498C9.81816 8.97172 9.33567 9.24414 9.08072 9.42286C8.93673 9.5238 8.88237 9.70178 8.91676 9.87424L9.83616 9.69094L9.90948 10.0587L9.02063 10.3952L9.10617 10.8243C9.2344 11.4675 9.85975 11.8849 10.5029 11.7567C10.5029 11.7567 10.1485 9.97917 11.9261 9.62479C13.7036 9.27041 14.058 11.0479 14.058 11.0479ZM15.5124 7.79451L13.6869 8.15845C13.452 8.20529 13.2413 7.99996 13.3118 7.77104C13.3753 7.56494 13.4556 7.38559 13.5618 7.21826C14.0232 6.49141 14.9286 6.22206 15.7729 6.05372C15.8987 6.02864 16.0211 6.1103 16.0462 6.23611L16.1627 6.82045C16.2521 7.26898 15.961 7.70509 15.5124 7.79451ZM12.5126 12.5669C13.1643 12.437 13.5872 11.8034 13.4573 11.1518C13.3274 10.5001 12.6938 10.0772 12.0422 10.2071C11.3905 10.337 10.9676 10.9706 11.0975 11.6222C11.2274 12.2739 11.861 12.6968 12.5126 12.5669ZM12.875 11.2678C12.9408 11.5979 12.7266 11.9188 12.3965 11.9846C12.0665 12.0504 11.7456 11.8362 11.6798 11.5061C11.614 11.1761 11.8282 10.8552 12.1582 10.7894C12.4883 10.7236 12.8092 10.9378 12.875 11.2678ZM2.97346 11.0479L-0.364044 10.2869L0.662442 5.13827C0.662442 5.13827 1.90669 5.17703 2.59319 5.5232C3.48689 5.97385 4.33793 7.40057 4.33793 7.40057C4.33793 7.40057 5.31615 8.56748 6.47768 8.81499C7.21327 8.97173 7.69575 9.24415 7.9507 9.42287C8.0947 9.52381 8.14905 9.70179 8.11467 9.87425L7.19526 9.69094L7.12194 10.0587L8.01079 10.3952L7.92525 10.8243C7.79702 11.4675 7.17167 11.8849 6.52849 11.7567C6.52849 11.7567 6.88287 9.97918 5.10536 9.6248C3.32784 9.27041 2.97346 11.0479 2.97346 11.0479ZM1.519 7.79452L3.34448 8.15846C3.57939 8.2053 3.79011 7.99996 3.71958 7.77105C3.65609 7.56495 3.57585 7.38559 3.46962 7.21826C3.00819 6.49142 2.10281 6.22207 1.25848 6.05373C1.13267 6.02865 1.01035 6.1103 0.985271 6.23611L0.86877 6.82046C0.779347 7.26899 1.07046 7.70509 1.519 7.79452ZM4.5188 12.5669C3.86715 12.437 3.44421 11.8034 3.57413 11.1517C3.70404 10.5001 4.33762 10.0772 4.98927 10.2071C5.64091 10.337 6.06385 10.9706 5.93394 11.6222C5.80402 12.2739 5.17044 12.6968 4.5188 12.5669ZM4.15642 11.2678C4.09062 11.5979 4.30483 11.9188 4.63489 11.9846C4.96494 12.0504 5.28584 11.8362 5.35164 11.5061C5.41745 11.1761 5.20323 10.8552 4.87318 10.7894C4.54312 10.7236 4.22222 10.9378 4.15642 11.2678ZM16.573 12.6875H0.666706V13.1562H16.573V12.6875Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_110_1076">
          <rect width="16" height="16" transform="translate(0.666718)" />
        </clipPath>
      </defs>{' '}
    </svg>
  );
}
